<div class="hx-sub-section__header-row">
  <button
    #headerButton
    class="hx-sub-section__header"
    type="button"
    [attr.aria-controls]="contentId"
    [attr.aria-describedby]="headerDescribedBy() ?? null"
    [attr.aria-expanded]="isExpanded()"
    [attr.id]="headerId"
    (click)="toggle()">
    <span class="hx-sub-section__heading">
      <span aria-hidden="true" class="hx-sub-section__icon">
        <ng-content select="[hxSubSectionIcon]" />
        @if (icon()) {
          <hx-icon [inline]="true" [svgIcon]="icon()" />
        }
      </span>

      <hx-label
        class="hx-sub-section__title"
        [attr.role]="'heading'"
        [attr.aria-level]="headingLevelAttr()"
        [description]="heading() || 'Untitled sub-section'"
        [subtitle]="subtitle()"
        [fontWeight]="labelFontWeight()"
        [fontSize]="labelFontSize()"
        [subtitleFontWeight]="subtitleFontWeight()"
        [subtitleFontSize]="subtitleFontSize()"
        [color]="labelColor()"
        [subtitleColor]="subtitleColor()"
        [tooltip]="tooltip()"
        [tooltipPosition]="tooltipPosition()"
        [tooltipColor]="tooltipColor()"></hx-label>
    </span>

    @if (showStatus()) {
      <span class="hx-sub-section__sr-status" [id]="statusId">
        {{ srStatusText() }}
      </span>
    }
  </button>
  <div class="hx-sub-section__header-actions">
    <ng-content select="[hxSubSectionAction]" />
  </div>
  @if (showStatus()) {
    <div
      class="hx-sub-section__badge hx-sub-section__badge--inline"
      [attr.data-status]="normalizedStatus()"
      role="status"
      [attr.aria-label]="statusPresentation().ariaDescription">
      <hx-icon
        aria-hidden="true"
        class="hx-sub-section__badge-icon"
        [inline]="true"
        [svgIcon]="statusPresentation().icon" />
      <span class="hx-sub-section__badge-label">{{ statusPresentation().label }}</span>
    </div>
  }
  <button
    type="button"
    class="hx-sub-section__meta hx-sub-section__toggle"
    [attr.aria-label]="isExpanded() ? 'Collapse subsection' : 'Expand subsection'"
    [attr.aria-controls]="contentId"
    [attr.aria-expanded]="isExpanded()"
    (click)="toggle()">
    <span aria-hidden="true" class="hx-sub-section__caret">
      <hx-icon fontIcon="chevron-up" />
    </span>
  </button>
</div>

<div
  #contentRegion
  class="hx-sub-section__content"
  role="region"
  [attr.aria-hidden]="isExpanded() ? null : 'true'"
  [attr.aria-labelledby]="headerId"
  [attr.id]="contentId"
  [attr.inert]="isExpanded() ? null : ''"
  [style.maxHeight.px]="isExpanded() ? contentHeight() : 0"
  [style.opacity]="isExpanded() ? 1 : 0">
  <div #bodyRegion class="hx-sub-section__body">
    <ng-content />
  </div>
</div>
